import React from 'react';
import PropTypes from 'prop-types';
import {FeedbackIcon} from '../FeedbackIcon';

const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'num',
};

export function InputCell(props) {
  const onChange = (event) => {
    let value = null;
    if (props.type === INPUT_TYPES.TEXT) {
      value = event.target.value;
    }
    if (props.type === INPUT_TYPES.NUMBER) {
      value = event.target.valueAsNumber;
    }
    props.onChange({id: props.id, value});
  };

  const setClassName = () => {
    let className = props.className;
    if (props.showFeedback) {
      className += ` ${props.isCorrect ? 'correct' : 'incorrect'}`;
    }
    return className;
  };

  return (
    <div className={setClassName()}>
      <input
        placeholder={props.placeholder}
        className={`${props.className}_input`}
        type={props.type}
        value={props.value}
        onChange={onChange}
        disabled={props.disabled}
      />
      <FeedbackIcon
        isSuccess={props.isCorrect}
        showFeedback={props.showFeedback}
        className={`${props.className}_feedback`}
        feedback={props.feedback}
      />
    </div>
  );
}

InputCell.propTypes = {
  /**
   * Unique id for the cell
   */
  id: PropTypes.string,
  /**
   * Placehodler for the cell
   */
  placeholder: PropTypes.string,
  /*
   * className to be set on component
   */
  className: PropTypes.string,
  /**
   * value to display on input
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * type of the input
   */
  type: PropTypes.oneOf(['text', 'num']),
  /**
   * Boolean feedback on value being correct/incorrect
   */
  isCorrect: PropTypes.bool,
};
